'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const DateTime = require('@grpn/preact-l10n/datetime');

function getDate(expiryDateTime) {
  if (!expiryDateTime) {
    return null;
  }

  return h(DateTime, { value: expiryDateTime, format: 'll' });
}

function MerchantOffersRow({
  offerTitle,
  offerType,
  isExclusive,
  expiryDateTime,
}) {
  return h('tr.offers-table-row', [
    h('td.offers-table-col', offerTitle),
    h('td.offers-table-col', [
      isExclusive && [h(Translate, 'modules.shared.Exclusive'), ' '],
      h(
        Translate,
        `modules.merchant.AnswerBoxOfferTypeDescription.${offerType}`
      ),
    ]),
    h('td.offers-table-col', getDate(expiryDateTime)),
  ]);
}

module.exports = MerchantOffersRow;
